Object.definePropertiesUnlessDefined(AbortSignal, {
    timeout: {
        value(timeout) {
            const controller = new AbortController();
            setTimeout(()=>controller.abort(), timeout);
            return controller.signal;
        }
    }
});